// margin, margin-top, margin-right, margin-bottom, margin-left, padding, padding-top
// padding-right, padding-bottom, padding-left, grid-gap, grid-column-gap, grid-row-gap
const space = [
    "0",
    "0.25rem",
    "0.5rem",
    "1rem",
    "2rem",
    "4rem",
    "8rem",
    "16rem",
    "32rem",
];
// font-size
const fontSizes = [12, 13, 14, 16, 18, 20, 22, 24, 26, 28, 32, 36, 42, 46];
export const fontTokens = {
    font01: ["2.875rem", "3.75rem"],
    font02: ["2.625rem", "3.25rem"],
    font03: ["2.25rem", "2.75rem"],
    font04: ["2rem", "2.5rem"],
    font05: ["1.75rem", "2.25rem"],
    font06: ["1.625rem", "2rem"],
    font07: ["1.5rem", "2rem"],
    font08: ["1.375rem", "1.75rem"],
    font09: ["1.25rem", "1.75rem"],
    font10: ["1.125rem", "1.5rem"],
    font11: ["1rem", "1.5rem"],
    font12: ["0.875rem", "1.25rem"],
    font13: ["0.8125rem", "1rem"],
    font14: ["0.75rem", "1rem"],
    defaultFont: "'AktivGrotesk', helvetica, arial, sans-serif",
};
// color, background-color, border-color
const colors = {
    // primary color
    cl17: "#376EB4",
    cl18: "#0A5A96",
    cl19: "#004673",
    // grey scale
    cl01: "#FFFFFF",
    cl02: "#FCFCFC",
    cl03: "#F7F7F7",
    cl04: "#F5F5F5",
    cl05: "#F1F1F1",
    cl06: "#E6E6E6",
    cl07: "#E3E3E3",
    cl08: "#D9D9D9",
    cl09: "#CCCCCC",
    cl10: "#B4B4B4",
    cl11: "#999999",
    cl12: "#707070",
    cl13: "#666666",
    cl14: "#5C5C5C",
    cl15: "#3D3D3D",
    cl16: "#000000",
    // signal colors
    cl20: "#008800",
    cl21: "#F07800",
    cl22: "#CE0000",
    // accent colors
    cl23: "#377B78",
    // chart qualitative
    cq01: "#376EB4",
    cq02: "#9BB6D9",
    cq03: "#4BA5A0",
    cq04: "#A5D2CF",
    cq05: "#646468",
    cq06: "#B1B1B3",
    cq07: "#B4A078",
    cq08: "#D9CFBB",
    cqdark01: "#E6E6E6",
    cqdark02: "#BFD1DC",
    cqdark03: "#4BA5A0",
    cqdark04: "#388D95",
    cqdark05: "#92B0E6",
    cqdark06: "#6D95C9",
    cqdark07: "#B4A078",
    cqdark08: "#878977",
    // chart diverging
    cd01: "#376EB4",
    cd02: "#6C8AC1",
    cd03: "#97A8CD",
    cd04: "#BFC6DA",
    cd05: "#E6E6E6",
    cd06: "#C2D6D4",
    cd07: "#A0C2C6",
    cd08: "#77B5B1",
    cd09: "#4BA5A0",
    // chart diverging
    cs01: "#376EB4",
    cs02: "#517ABA",
    cs03: "#6787BF",
    cs04: "#7B94C5",
    cs05: "#8EA1CB",
    cs06: "#A0AED0",
    cs07: "#B2BCD6",
    cs08: "#C3CADB",
    cs09: "#D5D8E1",
    cs10: "#E6E6E6",
    csdark01: "#F7F7F7",
    csdark02: "#E1E7EF",
    csdark03: "#CCD8E8",
    csdark04: "#B6C9E0",
    csdark05: "#A1B9D9",
    csdark06: "#8CAAD1",
    csdark07: "#769BCA",
    csdark08: "#618CC3",
    csdark09: "#4C7DBB",
    csdark10: "#376EB4",
};
colors.white = colors.cl01;
colors.offWhite = colors.cl02;
colors.grey03 = colors.cl03;
colors.grey04 = colors.cl04;
colors.grey05 = colors.cl05;
colors.grey06 = colors.cl06;
colors.grey07 = colors.cl07;
colors.grey08 = colors.cl08;
colors.grey09 = colors.cl09;
colors.grey10 = colors.cl10;
colors.grey11 = colors.cl11;
colors.grey12 = colors.cl12;
colors.grey13 = colors.cl13;
colors.grey14 = colors.cl14;
colors.grey15 = colors.cl15;
colors.black = colors.cl16;
colors.success = colors.cl20;
colors.warning = colors.cl21;
colors.error = colors.cl22;
colors.primaryLight = colors.cl17;
colors.primary = colors.cl18;
colors.primaryDark = colors.cl19;
colors.transparentPrimaryLight = "55,110,180";
colors.transparent13 = "102,102,102";
colors.transparent15 = "61,61,61";
colors.transparentWhite = "255,255,255";
colors.transparentBlack = "0,0,0";
colors.transparentSuccess = "0, 136, 0";
colors.transparentWarning = "240, 120, 0";
colors.transparentError = "206, 0, 0";
colors.transparent = "rgba(255, 255, 255, 0)";
colors.lightHover = "rgba(0, 0, 0, 0.04)";
colors.darkHover = "rgba(0, 0, 0, 0.08)";
colors.blackHover = "rgba(0, 0, 0, 0.12)";
// font-family
const fonts = {
    sans: "AktivGrotesk, Arial, Sans-serif",
    serif: "AktivGrotesk, Arial, Sans-serif",
    body: "AktivGrotesk, Arial, Sans-serif",
    heading: "AktivGrotesk, Arial, Sans-serif",
    monospace: "monospace",
    decorative: "AktivGrotesk, Arial, Sans-serif",
};
// font-weight
const fontWeights = {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    regular: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
    body: 400,
    heading: 700,
};
// line-height
const lineHeights = [16, 20, 24, 28, 32, 36, 44, 52, 60];
// letter-spacing
const letterSpacings = {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0em",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em",
};
// width, height, min-width, max-width, min-height, max-height
const sizes = {
    "0": "0",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "8": "2rem",
    "10": "2.5rem",
    "12": "3rem",
    "16": "4rem",
    "20": "5rem",
    "24": "6rem",
    "32": "8rem",
    "40": "10rem",
    "48": "12rem",
    "56": "14rem",
    "64": "16rem",
    px: "1px",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    prose: "65ch",
    "1/2": "50%",
    "1/3": "33.333333%",
    "2/3": "66.666667%",
    "1/4": "25%",
    "2/4": "50%",
    "3/4": "75%",
    "1/5": "20%",
    "2/5": "40%",
    "3/5": "60%",
    "4/5": "80%",
    "1/6": "16.666667%",
    "2/6": "33.333333%",
    "3/6": "50%",
    "4/6": "66.666667%",
    "5/6": "83.333333%",
    "1/12": "8.333333%",
    "2/12": "16.666667%",
    "3/12": "25%",
    "4/12": "33.333333%",
    "5/12": "41.666667%",
    "6/12": "50%",
    "7/12": "58.333333%",
    "8/12": "66.666667%",
    "9/12": "75%",
    "10/12": "83.333333%",
    "11/12": "91.666667%",
    full: "100%",
    screenHeight: "100vh",
    screenWidth: "100vw",
};
// border-width
const borderWidths = {
    "0": "0px",
    "2": "2px",
    "4": "4px",
    "8": "8px",
    default: "1px",
};
// border-style
const borderStyles = {
    solid: "solid",
    dashed: "dashed",
    dotted: "dotted",
};
// border-radius
const radii = {
    none: "0px",
    sm: "0.125rem",
    default: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px",
};
// box-shadow, text-shadow
const shadows = {
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    default: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
};
// z-index
const zIndices = {
    "0": 0,
    "10": 10,
    "20": 20,
    "30": 30,
    "40": 40,
    "50": 50,
    "60": 60,
    "70": 70,
    "80": 80,
    "90": 90,
    auto: "auto",
};
// breakpoints
const breakpoints = ["20rem", "48rem", "64rem", "80rem"];
// media queries
export const device = {
    xsmall: "(min-width: 0)",
    small: `(min-width: ${breakpoints[0]})`,
    medium: `(min-width: ${breakpoints[1]})`,
    large: `(min-width: ${breakpoints[2]})`,
    xlarge: `(min-width: ${breakpoints[3]})`,
    touch: `(hover: none) and (pointer: coarse) and (min-width: 0) and (max-width: ${breakpoints[1]})`,
};
const mediaQueries = {
    small: `@media screen and (min-width: ${breakpoints[0]})`,
    medium: `@media screen and (min-width: ${breakpoints[1]})`,
    large: `@media screen and (min-width: ${breakpoints[2]})`,
};
// transforms
const transforms = {
    transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left",
    },
    translate: {
        "0": "0",
        "1": "0.25rem",
        "2": "0.5rem",
        "3": "0.75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "8": "2rem",
        "10": "2.5rem",
        "12": "3rem",
        "16": "4rem",
        "20": "5rem",
        "24": "6rem",
        "32": "8rem",
        "40": "10rem",
        "48": "12rem",
        "56": "14rem",
        "64": "16rem",
        px: "1px",
        "-full": "-100%",
        "-1/2": "-50%",
        "1/2": "50%",
        full: "100%",
    },
    scale: {
        "0": "0",
        "50": ".5",
        "75": ".75",
        "90": ".9",
        "95": ".95",
        "100": "1",
        "105": "1.05",
        "110": "1.1",
        "125": "1.25",
        "150": "1.5",
    },
    rotate: {
        "0": "0",
        "45": "45deg",
        "90": "90deg",
        "180": "180deg",
        "-180": "-180deg",
        "-90": "-90deg",
        "-45": "-45deg",
    },
    skew: {
        "0": "0",
        "3": "3deg",
        "6": "6deg",
        "12": "12deg",
        "-12": "-12deg",
        "-6": "-6deg",
        "-3": "-3deg",
    },
};
// transitions
const transitions = {
    property: {
        none: "none",
        all: "all",
        default: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
        colors: "background-color, border-color, color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform",
    },
    timingFunction: {
        default: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)",
    },
    duration: {
        "75": "75ms",
        "100": "100ms",
        "150": "150ms",
        "200": "200ms",
        "300": "300ms",
        "500": "500ms",
        "700": "700ms",
        "1000": "1000ms",
        default: "150ms",
    },
};
export const disableTapHighlight = `
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
`;
export const global = {
    disableTapHighlight,
};
export const baseTheme = {
    space,
    global,
    fontSizes,
    colors,
    fonts,
    fontWeights,
    fontTokens,
    lineHeights,
    letterSpacings,
    sizes,
    borderWidths,
    borderStyles,
    radii,
    shadows,
    zIndices,
    breakpoints,
    mediaQueries,
    transforms,
    device,
    transitions,
};
